import { render, staticRenderFns } from "./AllTransactionActivities.vue?vue&type=template&id=31d25b3c"
import script from "./AllTransactionActivities.vue?vue&type=script&lang=ts"
export * from "./AllTransactionActivities.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports